import create from 'zustand';
import produce from 'immer';
import { onSnapshot, getFirestore, collection, doc, query, where } from 'firebase/firestore';
import { request, auth } from '../libs/utils';

const useSpaceStore = create((set, get) => {
    return {
        spaces: [],
        open: async (id) => {
            const space = await (await request(`/api/space/${id}`)).json();
            set(space);
            const db = getFirestore();
            const q = query(collection(db, 'pesu.rooms'), where('spaceId', '==', id));
            onSnapshot(q, coll => {
                coll.forEach(doc => {
                    set(state => produce(state, draft => {
                        const index = state.rooms.findIndex(r => r.id === doc.id);
                        if (index === -1) draft.rooms.push(doc.data());
                        else draft.rooms[index] = doc.data();
                    }));
                });
            });
        },
        getAll: async () => {
            const { spaces } = await (await request('/api/space')).json();
            set({ spaces });
        },
        get: async id => {
            const space = await (await request(`/api/space/${id}`)).json();
            set(state => produce(state, draft => {
                const index = state.spaces.findIndex(s => s.id === id);
                if(index === -1) draft.spaces.push(space);
                else draft.spaces[index] = space;
            }));
            return space;
        },
        getByCode: async code => {
            const space = await (await request(`/api/space/code/${code}`)).json();
            return space;
        },
        create: async ({name, size}) => {
            return await (await request('/api/space', 'POST', { name, size })).json();
        },
        createRoom: async ({ name, type, spaceId, pos }) => {
            return await (await request(`/api/space/${spaceId}/room`, 'POST', { name, type, pos })).json();
        },
        getRooms: async (spaceId) => {
            
        }
    }
});

export { useSpaceStore };